// Edit account parameters.
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { isIOSDevice, isInstalledWebApp, pushConfigured } from '../lib/push-capabilities.js';
import CheckBox from '../widgets/checkbox.jsx';

export default class AccNotificationsView extends React.PureComponent {
  constructor(props) {
    super(props);

    this.previewSound = null;
    this.state = {soundError: ''};
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
  }

  handleCheckboxClick(what, checked) {
    if (what == 'sound') {
      this.props.onToggleMessageSounds(checked);
    } else if (what == 'alert') {
      this.props.onTogglePushNotifications(checked);
    }
  }

  componentWillUnmount() {
    this.previewSound?.pause();
  }

  previewNotificationSound() {
    this.previewSound ||= new Audio('audio/vibe-notification-v1.m4a');
    this.previewSound.currentTime = 0;
    this.setState({soundError: ''});
    this.previewSound.play().catch(() => this.setState({soundError: 'Не удалось воспроизвести звук. Проверьте громкость и разрешение браузера.'}));
  }

  render() {
    const configured = pushConfigured(typeof FIREBASE_INIT !== 'undefined' ? FIREBASE_INIT : null);
    const installRequired = isIOSDevice() && !isInstalledWebApp();
    const canEnable = this.props.desktopAlertsEnabled && configured && !installRequired;
    return (
        <div className="scrollable-panel">
          <div className="vibe-sound-card">
            <strong>Vibe · мягкий звон</strong>
            <p>Короткие стеклянные ноты с лёгким эхом.</p>
            <button type="button" className="flat-button" onClick={() => this.previewNotificationSound()}>
              <i className="material-icons" aria-hidden="true">play_circle_outline</i> Послушать
            </button>
            <p className="vibe-settings-hint">В веб-версии звук играет внутри открытого приложения. Системный звук Android подключим в APK.</p>
            {this.state.soundError && <p role="alert">{this.state.soundError}</p>}
          </div>
          <div className="panel-form-row">
            <label htmlFor="message-sound">
              <FormattedMessage id="label_message_sound" defaultMessage="Message sound:"
                description="Label for message sounds toggle" />
            </label>
            <CheckBox name="sound" id="message-sound"
              checked={this.props.messageSounds} onChange={this.handleCheckboxClick} />
          </div>
          <div className="panel-form-row">
            <label htmlFor="desktop-alerts">
            {this.props.desktopAlertsEnabled ?
              <FormattedMessage id="label_push_notifications" defaultMessage="Background notifications:"
                description="Label for push notifications switch" />
              :
              <FormattedMessage id="label_push_notifications_disabled"
                defaultMessage="Notification alerts (requires HTTPS):"
                description="Label for push notifications switch" />
            }
            </label>
            <CheckBox name="alert" id="desktop-alerts"
              checked={configured && this.props.desktopAlerts}
              onChange={canEnable ? this.handleCheckboxClick : null} />
          </div>
          <p className="panel-form-row" role="note">
            {installRequired
              ? 'На iPhone: откройте Vibe в Safari → «Поделиться» → «На экран Домой». Затем запустите Vibe через значок, войдите и включите уведомления. Нужна iOS 16.4 или новее.'
              : !configured
                ? 'Фоновые уведомления пока недоступны: серверная доставка не настроена. Разрешение браузера само по себе не обеспечит доставку при закрытом приложении.'
                : !this.props.desktopAlertsEnabled
                  ? 'Для уведомлений откройте установленный Vibe по HTTPS.'
                  : this.props.desktopAlerts
                    ? 'Устройство подписано на push. Доставка при закрытом приложении зависит от настройки сервера и разрешений системы.'
                    : 'Включите уведомления и разрешите их в системном запросе. После настройки сервера они смогут приходить при закрытом Vibe.'}
          </p>
        </div>
    );
  }
};
